import _pluralize from "pluralize";

export const pluralize = (word: string, count: number) => {
  if (
    ["feedback", "alignment", "coaching"].includes(String(word).toLowerCase())
  ) {
    return _pluralize(word, 1);
  }
  if (["need"].includes(String(word).toLowerCase())) {
    return `${word}${count === 1 ? "s" : ""}`;
  }
  return _pluralize(word, count);
};

export const capitalize = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1);

const smallWordsRegexp =
  /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;

export const titleCase = (str: string) => {
  return str.replace(
    /[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g,
    function (match, index, title) {
      if (
        index > 0 &&
        index + match.length !== title.length &&
        match.search(smallWordsRegexp) > -1 &&
        title.charAt(index - 2) !== ":" &&
        (title.charAt(index + match.length) !== "-" ||
          title.charAt(index - 1) === "-") &&
        title.charAt(index - 1).search(/[^\s-]/) < 0
      ) {
        return match.toLowerCase();
      }

      if (match.substr(1).search(/[A-Z]|\../) > -1) {
        return match;
      }

      return match.charAt(0).toUpperCase() + match.substr(1);
    },
  );
};

export const lowerCase = (str: string, accronyms = false) => {
  if (accronyms) {
    return str.toLowerCase();
  }
  return str
    .split(" ")
    .map((word) => {
      if (/[A-Z]/.test(str.slice(1))) {
        return word;
      }
      return word.toLowerCase();
    })
    .join(" ");
};

export const removeBreaklines = (str = "", replaceBy = " ") => {
  return str.replace(/(\r\n|\n|\r)/gm, replaceBy);
};

export const joinStringWithCommaAnd = (arr: string[]) => {
  if (arr.length === 0) return "";
  if (arr.length === 1) return arr[0];
  const firsts = arr.slice(0, arr.length - 1);
  const last = arr[arr.length - 1];
  return firsts.join(", ") + " and " + last;
};

export function sanitizeMarkdown(md = ""): string {
  let out = md;

  // 1) If there's a [text](... with no closing ')' yet -> show just "text"
  //    Handle images first (leading !) then normal links.
  out = out.replace(/!\[([^\]]*)\]\([^)]*$/g, "$1"); // image with missing ')'
  out = out.replace(/\[([^\]]*)\]\([^)]*$/g, "$1"); // link with missing ')'

  // 2) Remove any unmatched '[' (and a preceding '!' if it's an image)
  //    This handles the case "Here is a [Googl" -> "Here is a Googl"
  out = removeUnclosedOpeningBrackets(out);

  return out;
}

/** remove '[' characters that never got closed by a ']' */
function removeUnclosedOpeningBrackets(md: string): string {
  const chars = Array.from(md);
  const openStack: number[] = [];

  for (let i = 0; i < chars.length; i++) {
    const c = chars[i];
    if (c === "[") {
      openStack.push(i);
    } else if (c === "]") {
      if (openStack.length) openStack.pop();
    }
  }

  // remove unmatched '[' from right -> left so indexes don't shift incorrectly
  for (let i = openStack.length - 1; i >= 0; i--) {
    const idx = openStack[i];
    // if it's an image opening like "![", remove the '!' too
    if (idx > 0 && chars[idx - 1] === "!") {
      chars.splice(idx - 1, 2); // remove '!' and '['
    } else {
      chars.splice(idx, 1); // remove '[' only
    }
  }

  return chars.join("");
}
